import ro from "/src/content/ro.json";

export const navLinks = ro.nav.links;
